import { countConversationsAssignedUniqueCustomer } from '../queries/countConversationsAssignedUniqueCustomer'

export const totalConversationsAssignedCustomersGauge = {
  description:
    'Total amount of customers that sent in a conversations (one customer may have multiple conversations) including spam and deleted conversations over your selected time period.',
  queries: [countConversationsAssignedUniqueCustomer],
  title: 'Assigment Customers',
}
